import React, { Component, createRef } from 'react'
import '../../css/App.scss'
import { APP_URL } from '../utils/config.js'
import OutsideClickHandler from '../HOC/outsideClickHandler.js'
import { connect } from 'react-redux'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import {
  setCanProceedToNextStep,
  setIsConnected,
  setSelectedDimensions,
  setSelectedStyle,
  setZipperOrientation,
} from '../actions/generalActions.js'
import _ from 'lodash'
import { BarLoader } from 'react-spinners'
import {
  capitalizeWord,
  displayToast,
  getDimensionsFromParams,
  getEstimate,
  getHasZipperOrientation,
  scrollTo,
  sendGtag,
} from '../utils/utils.js'
import { setCushionDimensions } from '../actions/cushionActions.js'
import ZipperOrientationCards from './DimensionsPage/ZipperOrientationCards.js'
import Button from './Templates/Button.js'
import StepTitle from './StepTitle/index.js'
import { ReactComponent as Arrow } from '../../assets/icons/arrow.svg'

// Backgrounds components
import OneSeatOneBack from './DimensionsImage/Loveseat/OneSeatOneBack.js'
import OneSeatTwoBack from './DimensionsImage/Loveseat/OneSeatTwoBack.js'
import TwoSeatOneBack from './DimensionsImage/Loveseat/TwoSeatOneBack.js'
import TwoSeatTwoBack from './DimensionsImage/Loveseat/TwoSeatTwoBack .js'

import SofaOneSeatOneBack from './DimensionsImage/Sofa/OneSeatOneBack.js'
import SofaOneSeatTwoBack from './DimensionsImage/Sofa/OneSeatTwoBack.js'
import SofaTwoSeatOneBack from './DimensionsImage/Sofa/TwoSeatOneBack.js'
import SofaTwoSeatTwoBack from './DimensionsImage/Sofa/TwoSeatTwoBack.js'
import SofaOneSeatThreeBack from './DimensionsImage/Sofa/OneSeatThreeBack.js'
import SofaThreeSeatOneBack from './DimensionsImage/Sofa/ThreeSeatOneBack.js'
import SofaThreeSeatThreeBack from './DimensionsImage/Sofa/ThreeSeatThreeBack.js'

import RectangleOneBreak from './DimensionsImage/Chaise/RectangleOneBreak.js'
import RoundedRectangleOneBreak from './DimensionsImage/Chaise/RoundedRectangleOneBreak.js'
import RectangleTwoBreaks from './DimensionsImage/Chaise/RectangleTwoBreaks.js'
import RoundedRectangleTwoBreaks from './DimensionsImage/Chaise/RoundedRectangleTwoBreaks.js'
import RectangleThreeBreaks from './DimensionsImage/Chaise/RectangleThreeBreaks.js'
import RoundedRectangleThreeBreaks from './DimensionsImage/Chaise/RoundedRectangleThreeBreaks.js'
import Toss from './DimensionsImage/Pillows/Toss.js'
import Bolster from './DimensionsImage/Pillows/Bolster.js'
import Lumbar from './DimensionsImage/Pillows/Lumbar.js'
import CustomDimensions from './DimensionsImage/Custom/CustomDimensions'
import ChairOneSeatOneBack from './DimensionsImage/Chair/OneSeatOneBack'
import BenchBackRoundedTop from './DimensionsImage/BenchBack/BackRoundedTop.js'
import BenchBackRoundedBottom from './DimensionsImage/BenchBack/BackRoundedBottom.js'
import BenchBackRoundedCorners from './DimensionsImage/BenchBack/BackRoundedCorners.js'
import BenchBackSquaredCorners from './DimensionsImage/BenchBack/BackSquaredCorners.js'
import BenchBackTrapezoidBack from './DimensionsImage/BenchBack/BackTrapezoidBack.js'
import BenchBackTrapezoidFront from './DimensionsImage/BenchBack/BackTrapezoidFront.js'
import ChairWithNoBack from './DimensionsImage/Chair/NoBack.js'

import CushionJointerTypeCard from './DimensionsPage/CushionJointerTypeCard'
import SeatTrapezoidFront from './DimensionsImage/BenchSeat/SeatTrapezoidFront.js'
import SeatTrapezoidBack from './DimensionsImage/BenchSeat/SeatTrapezoidBack.js'
import SeatRectangle from './DimensionsImage/BenchSeat/SeatRectangle.js'
import SeatRounded from './DimensionsImage/BenchSeat/SeatRounded.js'
import SeatRoundedFront from './DimensionsImage/BenchSeat/SeatRoundedFront.js'
import SeatRoundedBack from './DimensionsImage/BenchSeat/SeatRoundedBack.js'
import Circle from './DimensionsImage/BenchSeat/Circle.js'
import OttomanOneSeat from './DimensionsImage/Ottoman/OttomanOneSeat'

const letters = ['a', 'b', 'c', 'd', 'e', 'f']

const IMAGES = {
  'loveseat-1-seat-1-back-dimensions-3d.png': OneSeatOneBack,
  'loveseat-1-seat-2-back-dimensions-3d.png': OneSeatTwoBack,
  'loveseat-2-seat-1-back-dimensions-3d.png': TwoSeatOneBack,
  'loveseat-2-seat-2-back-dimensions-3d.png': TwoSeatTwoBack,
  'sofa-1-seat-1-back-dimensions-3d.png': SofaOneSeatOneBack,
  'sofa-1-seat-2-back-dimensions-3d.png': SofaOneSeatTwoBack,
  'sofa-2-seat-1-back-dimensions-3d.png': SofaTwoSeatOneBack,
  'sofa-2-seat-2-back-dimensions-3d.png': SofaTwoSeatTwoBack,
  'sofa-1-seat-3-back-dimensions-3d.png': SofaOneSeatThreeBack,
  'sofa-3-seat-1-back-dimensions-3d.png': SofaThreeSeatOneBack,
  'sofa-3-seat-3-back-dimensions-3d.png': SofaThreeSeatThreeBack,
  'rectangle-1-break-dimensions-3d.png': RectangleOneBreak,
  'rounded-rectangle-1-break-dimensions-3d.png': RoundedRectangleOneBreak,
  'rectangle-2-breaks-dimensions-3d.png': RectangleTwoBreaks,
  'rounded-rectangle-2-breaks-dimensions-3d.png': RoundedRectangleTwoBreaks,
  'rectangle-3-breaks-dimensions-3d.png': RectangleThreeBreaks,
  'rounded-rectangle-3-breaks-dimensions-3d.png': RoundedRectangleThreeBreaks,
  'toss-dimensions-3d.png': Toss,
  'bolster-dimensions-3d.png': Bolster,
  'lumbar-dimensions-3d.png': Lumbar,
  'custom-dimensions-3d.png': CustomDimensions,
  'chair-1-seat-1-back-dimensions-3d.png': ChairOneSeatOneBack,
  'squared-corners-dimensions-3d.png': SeatRectangle,
  'rounded-corners-dimensions-3d.png': SeatRounded,
  'rounded-front-dimensions-3d.png': SeatRoundedFront,
  'rounded-back-dimensions-3d.png': SeatRoundedBack,
  'bench-window-back-rounded-top-dimensions-3d.png': BenchBackRoundedTop,
  'bench-window-back-rounded-bottom-dimensions-3d.png': BenchBackRoundedBottom,
  'bench-window-back-rounded-corners-dimensions-3d.png': BenchBackRoundedCorners,
  'bench-window-back-squared-corners-dimensions-3d.png': BenchBackSquaredCorners,
  'bench-window-back-trapezoid-dimensions-3d.png': BenchBackTrapezoidBack,
  'zipper-reversed-bench-window-back-trapezoid-dimensions-3d.png': BenchBackTrapezoidFront,
  'trapezoid-front-dimensions-3d.png': SeatTrapezoidFront,
  'trapezoid-dimensions-3d.png': SeatTrapezoidFront,
  'trapezoid-back-dimensions-3d.png': SeatTrapezoidBack,
  'zipper-reversed-trapezoid-dimensions-3d.png': SeatTrapezoidBack,
  'zipper-reversed-trapezoid-back-dimensions-3d.png': SeatTrapezoidBack,
  'circle-dimensions-3d.png': Circle,
  'chair-with-no-back-dimensions-3d.png': ChairWithNoBack,
  'ottoman-1-seat-dimensions-3d.png': OttomanOneSeat,
}

const SPECIAL_CLASSNAME = {
  'custom-dimensions-3d.png': 'custom-dimensions',
  'chair-1-seat-1-back-dimensions-3d.png': 'chair-back-dimensions',
  'trapezoid-front-dimensions-3d.png': 'trapezoid-dimensions',
  'trapezoid-back-dimensions-3d.png': 'trapezoid-dimensions',
  'bench-window-back-trapezoid-dimensions-3d.png': 'trapezoid-dimensions',
  'squared-corners-dimensions-3d.png': 'rectangle-dimensions',
  'rounded-corners-dimensions-3d.png': 'rectangle-dimensions',
  'bench-window-back-rounded-top-dimensions-3d.png': 'rectangle-dimensions',
  'bench-window-back-rounded-corners-dimensions-3d.png': 'rectangle-dimensions',
  'bench-window-back-rounded-bottom-dimensions-3d.png': 'rectangle-dimensions',
  'bench-window-back-squared-corners-dimensions-3d.png': 'rectangle-dimensions',
  'rounded-front-dimensions-3d.png': 'rectangle-dimensions',
  'rounded-back-dimensions-3d.png': 'rectangle-dimensions',
  'circle-dimensions-3d.png': 'circle-dimensions',
  'chair-with-no-back-dimensions-3d.png': 'chair-with-no-back',
  'lumbar-dimensions-3d.png': 'lumbar-dimensions',
  'ottoman-1-seat-dimensions-3d.png': 'ottoman-dimensions',
}

class CushionDesignerSelector extends Component {
  constructor(props) {
    super(props)

    const { general } = this.props
    const { dimensions } = general

    this.state = {
      // isMobileLayout: false,
      jointing: '',
      connected: dimensions?.jointing
        ? { label: 'Yes!', value: true }
        : {
            label: "No, don't connect them.",
            value: false,
          },
      isChairWithBack: false,
      isChaise: false,
      removeThicknessTwoInches: false,
      zipperOrientationPopupOpen: false,
    }
  }

  componentDidMount() {
    const { isChaise, connected } = this.state
    const { general, dispatch, cushion, params } = this.props
    const { dimensions, type } = general
    const { cushionDimensions } = cushion
    const hasZipperOrientation = getHasZipperOrientation(general)
    const dimensionsParams = params.dimensions
    const isNextPage = dimensionsParams.length === 1 && dimensionsParams[0] === 'dimensions'
    const dimensionsFromParams = getDimensionsFromParams(cushionDimensions, params)

    scrollTo('designer-body', 0)

    if (isNextPage && hasZipperOrientation) {
      this.setState({ zipperOrientationPopupOpen: true })
    }

    if (_.isEmpty(dimensions)) {
      dispatch(setCanProceedToNextStep(false))
      dispatch(setSelectedDimensions(dimensionsFromParams))
    } else {
      this.setState({
        jointing: dimensions.jointing,
      })
    }

    if (!_.isEmpty(cushionDimensions) && this._compareParamsWithAvailableDimensions()) {
      if (
        type?.id === 11786 &&
        (params?.dimensions[5] === 'join' || params?.dimensions[5] === 'pinch')
      ) {
        dispatch(setIsConnected(true))
        this.setState({
          connected: { label: 'Yes!', value: true },
        })
      }
      dispatch(setCanProceedToNextStep(true))
      if (isChaise) {
        this.setState({
          jointing: dimensionsFromParams.jointing,
        })
      }
      this.getPrice()
    }
    if (type || params?.type?.id === '11786' || params?.type?.id === '11568') {
      const isChairWithBack = type?.id === 11786 || params?.type?.id === '11786' // 11569

      this.setState({
        isChairWithBack,
        isChaise: type?.id === 11568 || params?.type?.id === '11568',
      })

      if (isChairWithBack) {
        sendGtag('connected_seat_back', `${general?.type?.name}_${connected.value ? 'yes' : 'no'}`)
      }
    }

    if (cushionDimensions) {
      this._initializeRefs()
    }

    window.addEventListener('resize', this.checkForMobileLayout)
    window.addEventListener('load', this.checkForMobileLayout)
  }

  componentDidUpdate(prevProps, prevState) {
    const { connected, jointing } = this.state
    const { cushion, dispatch, general, params } = this.props
    const { cushionDimensions } = cushion
    const { dimensions, type, shape, zipperOrientation } = general
    const hasZipperOrientation = getHasZipperOrientation(general)
    const dimensionsParams = params.dimensions
    const newZipperOrientation = dimensionsParams?.[dimensionsParams?.length - 1]
    const isPageAfterRefresh = !prevProps.general.shape && shape
    const dimensionsFromParams = getDimensionsFromParams(cushionDimensions, params)

    const isChairWithBack = type?.id === 11786 || params?.type?.id === '11786' // 11569
    const isChaise = type?.id === 11568 || params?.type?.id === '11568'

    if (
      !_.isEmpty(cushionDimensions) &&
      !_.isEqual(prevProps.cushion.cushionDimensions, cushionDimensions)
    ) {
      if (type && !_.isEqual(prevProps.general.type, type)) {
        if (params?.type?.id === '11786' || params?.type?.id === '11568') {
          this.setState({
            isChairWithBack,
            isChaise,
          })
        }
      }
      if (
        !_.isEmpty(dimensionsFromParams) &&
        this._compareParamsWithAvailableDimensions(isChaise)
      ) {
        dispatch(setCanProceedToNextStep(true))

        // here we have a get price if all the dimensions are available
        this.getPrice()
        if (dimensionsFromParams.jointing) {
          this.setState({
            jointing: dimensionsFromParams.jointing,
            connected: { label: 'Yes!', value: true },
          })
        }
      } else if (_.isEmpty(dimensions)) {
        dispatch(setCanProceedToNextStep(false))
      }
      if (
        type?.id === 11786 &&
        (params?.dimensions[5] === 'join' || params?.dimensions[5] === 'pinch')
      ) {
        this.setState({
          connected: { label: 'Yes!', value: true },
        })
        dispatch(setIsConnected(true))
      }

      this._initializeRefs()
    }

    if (prevProps.general.dimensions !== dimensions && prevProps.general.shape !== shape && shape) {
      if (dimensions.width > 4) {
        dispatch(setSelectedStyle(null))
      }
    }

    if (isNaN(zipperOrientation) && newZipperOrientation && !isNaN(newZipperOrientation)) {
      dispatch(setZipperOrientation(parseInt(newZipperOrientation)))
    } else if (
      newZipperOrientation === 'dimensions' &&
      isPageAfterRefresh &&
      hasZipperOrientation
    ) {
      this.setState({ zipperOrientationPopupOpen: true })
    }

    if (
      dimensions.jointing &&
      prevProps.general.dimensions.jointing !== dimensions.jointing &&
      dimensions.jointing.length > 1
    ) {
      this.getPrice()
    }

    // check if connected has changed
    if (prevState.connected !== connected && type?.id === 11786) {
      const dimensionsArray = Object.values(dimensions).filter(
        (dimension) => !['join', 'pinch', undefined].includes(dimension),
      )
      const cushionDimensionsArray = Object.values(cushionDimensions)
      const areAllDimensionsSelected = dimensionsArray.length === cushionDimensionsArray.length
      if (connected.value === true && !dimensions.jointing) {
        dispatch(setCanProceedToNextStep(false))
      }
      if (connected.value === true && (dimensions.jointing || jointing)) {
        dispatch(setCanProceedToNextStep(true))
      }
      if (connected.value === false && areAllDimensionsSelected) {
        dispatch(setCanProceedToNextStep(true))
      }
    }

    // check if jointing has changed
    if (
      prevProps.general.dimensions.seat_thickness !== dimensions.seat_thickness &&
      type?.id === 11786
    ) {
      if (dimensions.seat_thickness > 3 && dimensions.jointing === 'pinch') {
        dispatch(setCanProceedToNextStep(false))
        this.setState({
          jointing: '',
        })
        dispatch(
          setSelectedDimensions({
            ...dimensions,
            jointing: '',
          }),
        )
      }
    }

    if (type?.id === 11568) {
      const { general: prevGeneral } = prevProps
      const { dimensions: prevDimensions } = prevGeneral

      if (Object.keys(dimensions || {})?.length) {
        if (
          Object.keys(dimensions)?.some(
            (dimension) =>
              dimension !== 'jointing' && dimensions[dimension] !== prevDimensions[dimension],
          )
        ) {
          const totalLength = this._getTotalChaiseLength()

          if (totalLength > 120) {
            dispatch(setCanProceedToNextStep(false))
            displayToast('Total length cannot exceed 120', 'error')
          } else if (jointing) {
            dispatch(setCanProceedToNextStep(true))
          }
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkForMobileLayout)
  }

  _compareParamsWithAvailableDimensions = (isChaise = false) => {
    const { cushion = {}, params, general } = this.props
    const { dimensions } = general
    const { cushionDimensions = {} } = cushion

    let comparisonResult = cushionDimensions

    if (comparisonResult.width) {
      comparisonResult.width = comparisonResult.width.map((item) => item?.toString())
    }

    Object.values(cushionDimensions).forEach((cushionDimension, index) => {
      comparisonResult = comparisonResult && cushionDimension.includes(params.dimensions[index])
    })

    if (dimensions) {
      Object.values(cushionDimensions).forEach((cushionDimension, index) => {
        Object.values(dimensions)?.forEach((dimension) => {
          if (dimension?.toString() === cushionDimension[index]) {
            comparisonResult = true
          }
        })
      })
    }

    if (isChaise) {
      comparisonResult = comparisonResult && dimensions.jointing
    }

    return comparisonResult
  }

  _initializeRefs = () => {
    const { cushion } = this.props
    const { cushionDimensions } = cushion

    Object.keys(cushionDimensions).forEach((cushion) => {
      this[`${cushion}DropdownRef`] = createRef()
      this[`${cushion}DropdownMenuRef`] = createRef()
    })
    this.forceUpdate()
  }

  _checkDimensions = (dimensions) => {
    const { jointing, isChaise, isChairWithBack, connected } = this.state
    const { dispatch, cushion } = this.props
    const { cushionDimensions } = cushion
    const dimensionsArray = Object.values(dimensions).filter(
      (dimension) => !['join', 'pinch', '', undefined].includes(dimension),
    )

    const cushionDimensionsArray = Object.values(cushionDimensions)

    if (dimensionsArray.length === cushionDimensionsArray.length) {
      this.getPrice()
      if (isChaise || (isChairWithBack && connected.value)) {
        dispatch(setSelectedDimensions({ ...dimensions, jointing })).then(() => {
          const totalLength = this._getTotalChaiseLength()

          if (totalLength > 120) {
            dispatch(setCanProceedToNextStep(false))
          } else if (jointing) {
            dispatch(setCanProceedToNextStep(true))
          }
        })
      } else {
        dispatch(setCanProceedToNextStep(true))
      }
    } else {
      dispatch(setCanProceedToNextStep(false))
    }
  }

  triggerGetPrice = () => {
    const { dispatch, general, params } = this.props
    getEstimate(dispatch, general, params)()
  }

  getPrice = (timeout = 100) => {
    setTimeout(() => {
      this.triggerGetPrice()
    }, timeout)
  }

  _changeDropdownColor = (type) => () => {
    this[`${type}DropdownMenuRef`].current.className =
      'dd-menu menu-active dimension-dropdown-options-body dropdown-active'
    this[`${type}DropdownRef`].current.className = 'dd-button dd-active dimension-dropdown-input'
  }

  _setDimension = (dimension) => (e) => {
    const { jointing, isChairWithBack, isChaise, connected } = this.state
    const { general, cushion, dispatch } = this.props
    const { dimensions, category, type } = general
    const { cushionDimensions, initialCushionDimensions } = cushion

    if (general?.dimensions?.[dimension] !== e.target.innerText) {
      sendGtag(`${dimension}_dimensions`, general?.type?.name)
    }

    if (
      dimension === 'thickness' &&
      isChaise &&
      parseFloat(e.target.innerText) > 3
    ) {
      dispatch(
        setSelectedDimensions({
          ...dimensions,
          [dimension]: e.target.innerText,
          jointing: jointing,
        }),
      )
    } else if (dimension === 'seat_thickness' && isChairWithBack && connected.value) {
      if (parseFloat(e.target.innerText) > 3) {
        this.setState({ jointing: 'join' })
        dispatch(
          setSelectedDimensions({
            ...dimensions,
            [dimension]: e.target.innerText,
            jointing: 'join',
          }),
        )
      } else {
        this.setState({ jointing: jointing })
        dispatch(
          setSelectedDimensions({
            ...dimensions,
            [dimension]: e.target.innerText,
            jointing: jointing,
          }),
        )
      }
    } else {
      let newDimensions = { ...dimensions, [dimension]: e.target.innerText }
      let shouldRemoveThicknessTwoInches = Object.values(newDimensions).some(
        (value) => parseFloat(value) >= 24.5,
      )
      this.setState({ removeThicknessTwoInches: shouldRemoveThicknessTwoInches })
      if (
        dimension !== 'thickness' &&
        shouldRemoveThicknessTwoInches &&
        parseFloat(dimensions.thickness) === 2
      ) {
        delete newDimensions.thickness
      }
      dispatch(setSelectedDimensions(newDimensions)).then(() => {
        if (
          parseFloat(newDimensions.back_height) >= 24.5 ||
          parseFloat(newDimensions.depth) >= 24.5 ||
          parseFloat(newDimensions.width) >= 24.5
        ) {
          const cushionDimensionsCopy = _.cloneDeep(cushionDimensions)
          const dimensionsCopy = { ...newDimensions }

          if ([884, 769].includes(category) || type?.id === 11786) {
            if (cushionDimensionsCopy.back_thickness && cushionDimensionsCopy.seat_thickness) {
              cushionDimensionsCopy.back_thickness = cushionDimensionsCopy.back_thickness?.filter(
                (dimension) => dimension !== '2',
              )
              cushionDimensionsCopy.seat_thickness = cushionDimensionsCopy.seat_thickness?.filter(
                (dimension) => dimension !== '2',
              )
            }

            if (cushionDimensionsCopy.thickness) {
              cushionDimensionsCopy.thickness = cushionDimensionsCopy.thickness?.filter(
                (dimension) => dimension !== '2',
              )
            }

            if (dimensions.back_thickness === '2') {
              delete dimensionsCopy.back_thickness
              dispatch(setCanProceedToNextStep(false))
            }

            if (dimensions.seat_thickness === '2') {
              delete dimensionsCopy.seat_thickness
              dispatch(setCanProceedToNextStep(false))
            }
          }

          dispatch(setSelectedDimensions(dimensionsCopy))
          dispatch(setCushionDimensions(cushionDimensionsCopy))
        } else {
          const initialDimensionsCopy = _.cloneDeep(initialCushionDimensions)
          dispatch(setCushionDimensions(initialDimensionsCopy))
        }
      })
      this._checkDimensions(newDimensions)
    }
    this._closeDropdown(dimension)()

    if (isChaise && dimension === 'thickness') {
      if (parseFloat(e.target.innerText) > 3) {
        dispatch(setCanProceedToNextStep(true))
      } else {
        dispatch(setCanProceedToNextStep(false))
      }
    }
  }

  _closeDropdown = (type) => () => {
    this[`${type}DropdownMenuRef`].current.className = 'dd-menu'
    this[`${type}DropdownRef`].current.className = 'dd-button dimension-dropdown-input'
  }

  _onJointingTypeChange = (option) => () => {
    const { jointing } = this.state
    const { general, dispatch } = this.props
    const { dimensions, isConnected, type } = general
    const totalLength = this._getTotalChaiseLength()
    const isChaise = type?.id === 11568 || type?.id === '11568'

    if (!isConnected && isChaise) {
      dispatch(setIsConnected(true))
      this.setState({
        connected: { label: 'Yes!', value: true },
      })
    }

    if (option === jointing) {
      this.setState({ jointing: undefined })

      dispatch(setSelectedDimensions({ ...dimensions, jointing: undefined }))

      if (isChaise && dimensions.thickness > 3) {
        dispatch(setCanProceedToNextStep(true))
      } else {
        dispatch(setCanProceedToNextStep(false))
      }

      return
    }

    this.setState({ jointing: option })

    dispatch(setSelectedDimensions({ ...dimensions, jointing: option }))
    if (totalLength <= 120) {
      dispatch(setCanProceedToNextStep(true))
    }
  }

  _onConnectedChange = (option) => () => {
    const { jointing } = this.state
    const { general, dispatch } = this.props
    const { dimensions } = general

    // TODO DANU
    this.setState({ connected: option })

    if (option.value === true) {
      dispatch(setIsConnected(true))
      dispatch(setSelectedDimensions({ ...dimensions, jointing }))
      if (parseFloat(dimensions.thickness) > 3 || parseFloat(dimensions.seat_thickness) > 3) {
        this.setState({ jointing: 'join' })
        dispatch(setSelectedDimensions({ ...dimensions, jointing: 'join' }))
      }
    }
    if (option.value === false) {
      dispatch(setIsConnected(false))
      let dimensionsWithoutJointing = dimensions
      delete dimensionsWithoutJointing.jointing
      dispatch(setSelectedDimensions({ ...dimensions }))
    }

    this.getPrice(200)

    sendGtag('connected_seat_back', `${general?.type?.name}_${option.value ? 'yes' : 'no'}`)
  }

  _getTotalChaiseLength = () => {
    const { general } = this.props
    const { dimensions } = general
    let totalLength = 0

    for (const dimension in dimensions) {
      if (!['width', 'thickness', 'jointing'].includes(dimension)) {
        totalLength += parseFloat(dimensions[dimension])
      }
    }

    return totalLength
  }

  _getDateForProperties(categoryId, type, set, shape, isZipperReversed) {
    const combinations = [
      {
        categoryId: 2893,
        shapeSlug: 'trapezoid',
        date: '2022/02',
      },
      {
        categoryId: 27,
        date: '2022/01',
      },
      {
        categoryId: 28,
        shapeSlug: 'trapezoid',
        typeId: 166,
        date: '2022/01',
      },
      {
        categoryId: 769,
        shapeSlug: 'trapezoid',
        typeId: 11658,
        date: '2022/02',
      },
      {
        categoryId: 884,
        shapeSlug: 'trapezoid',
        typeId: 12107,
        date: '2022/02',
      },
      {
        categoryId: 769,
        shapeSlug: 'trapezoid',
        typeId: 11660,
        date: '2022/02',
      },
      {
        set: { id: 875 },
        shape: { id: 787 },
        typeIds: [12090],
        date: '2021/12',
      },
      {
        set: { id: 875 },
        shape: { id: 787 },
        typeIds: [11864, 12090],
        date: '2022/02',
      },
      {
        shape: { id: 880 },
        date: '2022/02',
      },
      {
        shape: { id: 729 },
        typeId: 11660,
        date: '2022/02',
      },
      {
        typeId: 11658,
        date: '2022/03',
      },
    ]

    if (isZipperReversed) {
      return '2023/10'
    }

    const matchingCombination = combinations.find((combination) => {
      const hasCategoryId = !combination.categoryId || combination.categoryId === categoryId
      const hasType = !combination.typeId || type?.id === combination.typeId
      const hasSet = !combination.set || set?.id === combination.set.id
      const hasShape = !combination.shape || shape?.id === combination.shape.id
      const hasGeneralType = !combination.typeIds || combination.typeIds.includes(type?.id)
      const hasShapeSlug = !combination.shapeSlug || shape?.slug === combination.shapeSlug
      return hasCategoryId && hasType && hasSet && hasShape && hasGeneralType && hasShapeSlug
    })

    return matchingCombination?.date || '2021/12'
  }

  _getDateForProperties3D(type, shape, isZipperReversed) {
    if (isZipperReversed) {
      return '2023/10'
    } else if (shape?.id === 859) {
      return '2021/12'
    } else if (type?.id === 11658) {
      return '2022/04'
    }

    return '2021/11'
  }

  _handleMouseEnter = (id) => () => {
    const text = document.getElementById(`${id}-Text`)
    const background = document.getElementById(`${id}-Background`)
    const line = document.getElementById(`${id}-Line`)

    if (text) {
      text.style.fill = '#000000'
    }
    if (background) {
      background.style.fill = 'white'
    }
    if (line) {
      line.style.fill = 'white'
    }
  }

  _handleMouseLeave = (id) => () => {
    const text = document.getElementById(`${id}-Text`)
    const background = document.getElementById(`${id}-Background`)
    const line = document.getElementById(`${id}-Line`)
    const color = '#FFFFFF99'

    if (text) {
      text.style.fill = color
    }
    if (background) {
      background.style.fill = 'transparent'
    }
    if (line) {
      line.style.fill = color
    }
  }

  setZipperOrientation = (value) => () => {
    const { cushion, dispatch, general } = this.props
    const { cushionDimensions } = cushion

    if (general?.zipperOrientation !== value) {
      sendGtag('orientation_dimensions', `${general?.type?.name}_Orientation Value ${value}`)
    }

    dispatch(setZipperOrientation(value))
    this.setState({
      zipperOrientationPopupOpen: false,
    })

    if (!_.isEmpty(cushionDimensions) && this._compareParamsWithAvailableDimensions()) {
      this.getPrice()
    }
  }

  setZipperOrientationPopupOpen = (open) => () => {
    this.setState({ zipperOrientationPopupOpen: open })
  }

  getDimensionsNote = () => {
    const { general } = this.props
    const { type } = general

    return type?.id === 168 || type?.id === 11860 ? (
      <>
        <p>
          Pillow dimensions are based on measuring along the edge of the pillow, not the width of
          the stuffed pillow.
        </p>
        <p>
          Once filled with poly fiber, the height and width will be slightly less than the
          measurements ordered. For example, a 18&quot; × 18&quot; pillow will have a finished
          dimensions of 17&quot; × 17&quot; when filled.
        </p>
      </>
    ) : (
      <>
        <b>Please note:</b>
        <br />
        <p>
          Cushion Pros® is responsible for creating a finished product within a tolerance of
          one-half of an inch (1/2&quot;) of the dimensions provided by the customer.
        </p>
        {type?.id === 11858 ||
        type?.id === 166 ||
        type?.id === 11864 ||
        type?.id === 12090 ||
        type?.id === 11786 ? null : (
          <i>
            Width dimension greater than 24 inches requires thickness dimension to be 3 inches or
            greater. If you need 2 inch thickness, and your width dimension is greater than 24
            inches we recommend splitting the single cushion into multiple cushions.
          </i>
        )}
      </>
    )
  }

  _renderChairWithBackToggle = () => {
    const { connected } = this.state

    return (
      <div className="connected-container">
        <p>Should the back be connected to the seat?</p>
        <div className="connected-toggle">
          <div
            className={`connected-toggle-option ${connected.value ? 'active' : ''}`}
            onClick={this._onConnectedChange({ value: true })}
          >
            Yes
          </div>
          <div
            className={`connected-toggle-option ${!connected.value ? 'active' : ''}`}
            onClick={this._onConnectedChange({ value: false })}
          >
            No
          </div>
        </div>
      </div>
    )
  }

  getDimensionText(dimension) {
    const { general } = this.props
    const { type } = general
    let dimensionName = dimension

    if (type.id === 11658 && dimension === 'depth') {
      dimensionName = 'height'
    }

    return dimensionName
    .split('_')
    .map((word) => capitalizeWord(word))
    .join(' ')
  }

  render() {
    const {
      jointing,
      isChairWithBack,
      isChaise,
      removeThicknessTwoInches,
      zipperOrientationPopupOpen,
    } = this.state
    const { general, cushion, layout, params, currentLocationIndex } = this.props
    const { currentFlow } = layout
    const {
      dimensions,
      type,
      shape,
      set,
      individualRoundedBack,
      individualRoundedSeat,
      category,
      isConnected,
      zipperOrientation,
    } = general
    const { cushionDimensions, fetchingAttributeTermsById } = cushion
    // const { isMobileLayout } = this.state
    const dimensionsArray = Object.values(dimensions).filter(
      (dimension) => !['join', 'pinch', ''].includes(dimension) && dimension,
    )
    const cushionDimensionsArray = Object.values(cushionDimensions)
    const areAllDimensionsSelected = dimensionsArray.length === cushionDimensionsArray.length
    const showBreakTypeSelect =
      (isChairWithBack
        ? areAllDimensionsSelected && isConnected
        : isChaise
          ? areAllDimensionsSelected
          : false) && currentFlow !== 'filling-only'
    const isTrapezoid = general.shape?.slug === 'trapezoid'
    const hasZipperOrientation = getHasZipperOrientation(general)
    const isZipperReversed = hasZipperOrientation && zipperOrientation
    const isToss = general.type?.slug === 'toss'
    const isLumbar = general.type?.slug === 'lumbar'
    const isOttoman = general.type?.slug === 'ottoman'
    const isLoveseatOrSofa = [11864, 12090].includes(type?.id)
    let numberOfBacks, widthPerBack, totalChaiseLength
    const name = general?.type?.name

    if (isLoveseatOrSofa) {
      numberOfBacks = parseInt(set?.slug.split('-')[2])
      if (dimensions.width) {
        widthPerBack = (parseFloat(dimensions.width) / numberOfBacks).toFixed(2)
      }
    }

    if (isChaise) {
      totalChaiseLength = this._getTotalChaiseLength()
    }

    if (cushionDimensions === null || fetchingAttributeTermsById) {
      return (
        <div className={'dimensions'}>
          <BarLoader color={'#93C44E'} css={{ position: 'absolute', left: '50%', right: '50%' }} />
        </div>
      )
    }

    let threeDSlug = '',
      twoDSlug = '',
      classSlug = '',
      isCustom = general?.shape?.slug === 'custom'

    if ([11569, 12090, 11864, 11786, 166].includes(type?.id) && !isCustom) {
      threeDSlug = `${type.slug}-`
      twoDSlug = `${type.slug}-`
      classSlug = type.slug
    }

    threeDSlug += `${general?.set?.slug || params?.set?.slug || general?.shape?.slug || params?.shape?.name || general?.type?.slug}-dimensions-3d.png`
    twoDSlug += `${isCustom ? general?.shape?.slug : general?.set?.slug || params?.set?.slug || general?.shape?.slug || params?.shape?.name || general?.type?.slug}${(general?.set || params?.set) && !isCustom ? `${general?.additionalShape?.slug || params?.shape?.additionalShapeName ? `-${general?.additionalShape?.slug || params?.shape?.additionalShapeName}${individualRoundedSeat || individualRoundedBack ? '-individual' : ''}` : ''}-${general?.shape?.slug || params?.shape?.name}` : ''}-dimensions-2d.png`
    classSlug += ` ${(general?.set?.slug || params?.set?.slug) && !isCustom ? 'set-' : ''}${isCustom ? general?.shape?.slug : general?.set?.slug || params?.set?.slug || general?.shape?.slug || params?.shape?.name || general?.type?.slug}`

    if (general?.shape?.slug === 'trapezoid' || params?.shape?.name === 'trapezoid') {
      twoDSlug = `${general?.type?.slug}-${general?.shape?.slug || params?.shape?.name}-dimensions-2d.png`
      threeDSlug = `${general?.shape?.slug || params?.shape?.name}-${general?.zipperOrientation ? 'back' : 'front'}-dimensions-3d.png`
    }

    if (general?.type?.id === 11658) {
      twoDSlug = `bench-window-back-${general?.shape?.slug || params?.shape?.name}-dimensions-2d.png`
      threeDSlug = `${general?.type?.slug}-${general?.shape?.slug || params?.shape?.name}-dimensions-3d.png`
    }

    if (general?.type?.id === 12072) {
      threeDSlug = `${['circle', 'trapezoid'].includes(general?.shape?.slug) ? general?.shape?.slug : 'chair-with-no-back'}-dimensions-3d.png`
      if (general?.shape?.slug === 'circle' || general?.shape?.slug === 'trapezoid') {
        twoDSlug = `chair-with-no-back-${general?.shape?.slug || params?.shape?.name}-dimensions-2d-1.png`
      } else {
        twoDSlug = `${general?.shape?.slug || params?.shape?.name}-dimensions-2d.png`
      }
    }

    const imgBase = `${APP_URL}/wp-content/uploads/`
    const imgDate = this._getDateForProperties(category, type, set, shape, isZipperReversed)
    const imgZipper = isZipperReversed ? 'zipper-reversed-' : ''
    let img_link = `${imgBase}${imgDate}/${imgZipper}${twoDSlug}`

    const SelectedImageComponent = IMAGES[`${imgZipper}${threeDSlug}`]
    const specialClassName = SPECIAL_CLASSNAME[threeDSlug] || ''

    if (general?.type?.id === 11786 && shape?.id === 30) {
      img_link = `${APP_URL}/wp-content/uploads/2022/03/chair-1-seat-1-back-rounded-corners-rounded-corners-dimensions-2d.png`
    }

    if (general?.set?.id === 860) {
      const newWidthArray = []
      let i = 10
      while (i <= 120) {
        newWidthArray.push(i)
        i += 1
      }
      cushionDimensions.width = newWidthArray
    }

    if (
      (type?.id === 12090 && set?.id === 882) ||
      (type?.id === 12090 && set?.id === 876) ||
      (type?.id === 12090 && set?.id === 881) ||
      (type?.id === 12090 && set?.id === 877) ||
      (type?.id === 12090 && set?.id === 860) ||
      type?.id === 11786
    ) {
      const newWidthArray = []
      let i = 10
      while (i <= 120) {
        newWidthArray.push(i)
        i += 0.5
      }
      cushionDimensions.width = newWidthArray
    }

    return (
      <>
        <StepTitle
          name={name}
          step={currentLocationIndex - 1}
          attributes={general?.type?.attributes}
          customNote={general?.shape?.slug === 'custom'}
          additionalNote={this.getDimensionsNote()}
        />
        <div>
          <div className={'dimensions cushion-designer-layout'}>
            <div className={`dimensions-image ${specialClassName}`}>
              <p className={'cushion-designer-footer-text'}>
                Cushion Pros® is responsible for creating a finished product within a tolerance of
                one-half of an inch (1/2&ldquo;) of the dimensions provided by the customer. <br />{' '}
                <br />
                Width dimension greater than 24 inches requires thickness dimension to be 3 inches
                or greater. <br /> <br />
                If you need 2 inch thickness, and your width dimension is greater than 24 inches we
                recommend splitting the single cushion into multiple cushions.
              </p>
              {SelectedImageComponent ? (
                <SelectedImageComponent
                  totalWidth={!isNaN(widthPerBack) ? widthPerBack : ''}
                  totalChaiseLength={!isNaN(totalChaiseLength) ? totalChaiseLength : ''}
                />
              ) : null}
            </div>
            <div className={'dimensions-container'}>
              {/* TO DO - this might be deleted */}
              {/* {isMobileLayout ? (
                <div className={'bottom-text-mobile'}>
                  {type?.id === 168 || type?.id === 11860 ? (
                    <>
                      <p className="text">
                        Pillow dimensions are based on measuring along the edge of the pillow, not
                        the width of the stuffed pillow.
                      </p>
                      <p className="text">
                        Once filled with poly fiber, the height and width will be slightly less than
                        the measurements ordered. For example, a 18&quot; × 18&quot; pillow will
                        have a finished dimensions of 17&quot; × 17&quot; when filled.
                      </p>
                    </>
                  ) : (
                    <>
                      <p className={'bold-text'}>Please note:</p>
                      <p className={'text'}>
                        Cushion Pros® is responsible for creating a finished product within a
                        tolerance of one-half of an inch (1/2&quot;) of the dimensions provided by
                        the customer.
                      </p>
                      {type?.id === 11858 ||
                      type?.id === 166 ||
                      type?.id === 11864 ||
                      type?.id === 12090 ||
                      type?.id === 11786 ? null : (
                        <i>
                          Width dimension greater than 24 inches requires thickness dimension to be
                          3 inches or greater. If you need 2 inch thickness, and your width
                          dimension is greater than 24 inches we recommend splitting the single
                          cushion into multiple cushions.
                        </i>
                      )}
                    </>
                  )}
                </div>
              ) : null} */}
              <div className="models-visualisation">
                <div className={`visualisation-2d ${type?.slug}`}>
                  {hasZipperOrientation && !zipperOrientationPopupOpen && (
                    <Button
                      className="change-zipper-orientation-button"
                      onClick={this.setZipperOrientationPopupOpen(true)}
                    >
                      Change Orientation
                    </Button>
                  )}
                  {zipperOrientationPopupOpen ? (
                    <ZipperOrientationCards
                      zipperOrientation={zipperOrientation}
                      setZipperOrientation={this.setZipperOrientation}
                    />
                  ) : (
                    <>
                      <p
                        className={`enter-the-dimensions ${isTrapezoid ? 'trapezoid-2d' : ''}${isChaise ? 'chaise' : ''}${isToss || isLumbar ? 'toss' : ''}${isOttoman ? 'ottoman' : ''} ${isTrapezoid && !hasZipperOrientation ? 'no-zipper-orientation' : ''}`}
                      >
                        Enter the dimensions in INCHES in the
                        <br /> following order:
                      </p>
                      <img
                        alt="cushion"
                        className={'type'}
                        src={
                          type?.id === 13101 && shape?.id === 880
                            ? `${APP_URL}/wp-content/uploads/2022/02/chair-with-no-back-circle-dimensions-2d-1.png`
                            : img_link
                        }
                      />
                      <div className="dimensions-options-wrapper">
                        <div className={`dropdowns dimensions-options-container ${classSlug}`}>
                          <div className="dimensions-options-section-container">
                            {Object.keys(cushionDimensions).map((dimension, index) => {
                              return (
                                <div
                                  key={`${dimension}-${index}`}
                                  className={`dimension-option-card-wrapper attribute ${(general?.type?.id === 12072 || general?.type?.id === 11658 || general?.type?.id === 12107 || general?.type?.id === 11660) && dimension === 'back_width' ? dimension + '_trapezoid' : dimension}`}
                                  onMouseEnter={this._handleMouseEnter(
                                    letters[index].toUpperCase(),
                                  )}
                                  onMouseLeave={this._handleMouseLeave(
                                    letters[index].toUpperCase(),
                                  )}
                                >
                                  <div className="dimension-option-card-container">
                                    <div className="attribute-text-container">
                                      <div className={'attribute-text dimension-option-card-text'}>
                                        <p className="dimension-option-card-title">
                                          {letters[index].toUpperCase()}
                                        </p>
                                        <p className="dimension-option-card-description">{`${[11864, 12090].includes(type?.id) && index === 1 ? 'Total ' : ''}${this.getDimensionText(dimension)}`}</p>
                                      </div>
                                    </div>
                                    <label className={'dropdown'}>
                                      <OutsideClickHandler
                                        onOutsideClick={this._closeDropdown(dimension)}
                                      >
                                        <div
                                          id={`${dimension}-dropdown`}
                                          ref={this[`${dimension}DropdownRef`]}
                                          onClick={this._changeDropdownColor(dimension)}
                                          className="dd-button dimension-dropdown-input"
                                        >
                                          <p>{dimensions[dimension]}</p>
                                          <Arrow viewBox="0 0 8 12" width="12" height="8" />
                                        </div>
                                        <input type="checkbox" className={'dd-input'} />
                                        <ul
                                          ref={this[`${dimension}DropdownMenuRef`]}
                                          className="dd-menu dimension-dropdown-options-body"
                                        >
                                          {_.sortBy(
                                            cushionDimensions[dimension]?.map((value) =>
                                              parseFloat(value),
                                            ),
                                          )?.map((thicknessValue) => {
                                            if (
                                              dimension === 'thickness' &&
                                              removeThicknessTwoInches &&
                                              thicknessValue === 2
                                            ) {
                                              return null
                                            }
                                            return (
                                              <li
                                                className={
                                                  dimensions[dimension] ===
                                                  thicknessValue.toString()
                                                    ? 'selected'
                                                    : ''
                                                }
                                                onClick={this._setDimension(dimension)}
                                                key={thicknessValue}
                                              >
                                                {thicknessValue}
                                              </li>
                                            )
                                          })}
                                        </ul>
                                      </OutsideClickHandler>
                                    </label>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                          <div className="dimensions-options-section-container break-types-section">
                            {isChairWithBack && Object.keys(cushionDimensions)?.length
                              ? this._renderChairWithBackToggle()
                              : null}
                            {showBreakTypeSelect && Object.keys(cushionDimensions)?.length ? (
                              <>
                                {parseFloat(dimensions.thickness) < 4 ? (
                                  <CushionJointerTypeCard
                                    type="pinch"
                                    tooltipText="The construction of these cushions has a vertical sidewall that is the
                                      same height as the thickness of the cushion. These cushions are made by
                                      assembling the top and bottom section of the cut fabric to the sidewall
                                      fabric to form a box."
                                    isActive={jointing === 'pinch'}
                                    icon={`${APP_URL}/wp-content/uploads/2021/11/pinch.png`}
                                    onClickHandler={this._onJointingTypeChange('pinch')}
                                  />
                                ) : 'thickness' in dimensions && isChairWithBack ? (
                                  <div className="chair-with-back-break-placeholder">&nbsp;</div>
                                ) : null}
                                {parseFloat(dimensions.seat_thickness) < 4 ? (
                                  <CushionJointerTypeCard
                                    type="pinch"
                                    tooltipText="The construction of these cushions has a vertical sidewall that is the
                                      same height as the thickness of the cushion. These cushions are made by
                                      assembling the top and bottom section of the cut fabric to the sidewall
                                      fabric to form a box."
                                    isActive={jointing === 'pinch'}
                                    icon={`${APP_URL}/wp-content/uploads/2021/11/pinch.png`}
                                    onClickHandler={this._onJointingTypeChange('pinch')}
                                  />
                                ) : 'seat_thickness' in dimensions && isChairWithBack ? (
                                  <div className="chair-with-back-break-placeholder">&nbsp;</div>
                                ) : null}
                                <CushionJointerTypeCard
                                  type="join"
                                  tooltipText="Double-corded cushions are used for cushions with boxed edges whereas a
                                  small section of fabric is sewn into both the top and bottom seams of the
                                  sidewall fabric panel of the cushions along with the top and bottom fabric
                                  panels."
                                  isActive={jointing === 'join'}
                                  icon={`${APP_URL}/wp-content/uploads/2021/11/join.png`}
                                  onClickHandler={this._onJointingTypeChange('join')}
                                />
                              </>
                            ) : null}
                            {isChairWithBack &&
                            !showBreakTypeSelect &&
                            Object.keys(cushionDimensions)?.length ? (
                              <>
                                <div className="chair-with-back-break-placeholder">&nbsp;</div>
                                <div className="chair-with-back-break-placeholder">&nbsp;</div>
                              </>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* comment this if on staging */}
            {/* <div className='measure-cushions-blog'>
              <p>Having trouble measuring your cushions?</p>
              <p style={{ display: 'flex', paddingLeft: '3px', }}>Read our blog post <a style={{ paddingLeft: '3px', }}
                href={ `${APP_URL}/2021/12/02/creating-a-custom-cushion-for-beginners` }><b>here!</b></a></p>
            </div> */}
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  cushion: state.cushion,
  layout: state.layout,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionDesignerSelector))
